import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { registerCompany } from "../../../utils/services";

const Registermodal = ({ show, onHide }) => {
  const [showSubmitted, setShowSubmitted] = useState(false);
  const handleCloseSubmitted = () => setShowSubmitted(false);
  const handleShowSubmitted = () => setShowSubmitted(true);

  const [showUnable, setShowUnable] = useState(false);
  const handleCloseUnable = () => setShowUnable(false);
  const handleShowUnable = () => setShowUnable(true);

  const [form, setForm] = useState({
    companyName: "",
    ticker: "",
    contactName: "",
    website: "",
    email: "",
    message: "",
    agreed: false,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const newValue = type === "checkbox" ? checked : value;

    setForm({
      ...form,
      [name]: newValue,
    });

    setErrors((prev) => ({
      ...prev,
      [name]: false,
    }));
  };

  const validate = () => {
    let newErrors = {};

    if (!form.companyName.trim()) newErrors.companyName = true;
    if (!form.ticker.trim()) newErrors.ticker = true;
    if (!form.contactName.trim()) newErrors.contactName = true;
    if (!form.website.trim()) newErrors.website = true;

    if (!form.email.trim()) {
      newErrors.email = true;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
      newErrors.email = true;
    }

    if (!form.agreed) newErrors.agreed = true;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    try {
      setLoading(true);

      const payload = {
        companyName: form?.companyName,
        tickerSymbol: form?.ticker,
        contactName: form?.contactName,
        companyWebsite: form?.website,
        contactEmail: form?.email,
        message: form?.message,
      };

      await registerCompany(payload);

      setForm({
        companyName: "",
        ticker: "",
        contactName: "",
        website: "",
        email: "",
        message: "",
        agreed: false,
      });
      setErrors({});

      onHide();
      handleShowSubmitted();
    } catch (err) {
      handleShowUnable();
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Modal className="join" show={show} onHide={onHide} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <h2>Register Your Company</h2>
            <p>
              Companies can publish verified share structure data and maintain
              transparent records for investors on TRAQSTOCK.
            </p>
            <div className="maininputs">
              <div className="innerinput">
                <p>Company Name</p>
                <input
                  placeholder="Enter Company Name"
                  type="text"
                  name="companyName"
                  value={form.companyName}
                  onChange={handleChange}
                  className={errors.companyName ? "error" : ""}
                />
              </div>
              <div className="innerinput">
                <p>Ticker Symbol</p>
                <input
                  type="text"
                  name="ticker"
                  value={form.ticker}
                  onChange={handleChange}
                  placeholder="Enter ticker symbol e.g AAPL "
                  className={errors.ticker ? "error" : ""}
                />
              </div>
              <div className="innerinput">
                <p>Contact Full Name</p>
                <input
                  type="text"
                  name="contactName"
                  value={form.contactName}
                  onChange={handleChange}
                  placeholder="Enter Contact full name "
                  className={errors.contactName ? "error" : ""}
                />
              </div>
              <div className="innerinput">
                <p>Company Website</p>
                <input
                  type="text"
                  name="website"
                  value={form.website}
                  onChange={handleChange}
                  placeholder="https:// "
                  className={errors.website ? "error" : ""}
                />
              </div>
              <div className="innerinput">
                <p>Contact Email</p>
                <input
                  type="text"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  placeholder="Enter business email "
                  className={errors.email ? "error" : ""}
                />
              </div>
              <div className="innerinput">
                <p>Message (Optional)</p>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Tell us about your interest in publishing data on TRAQSTOCK"
                />
              </div>
            </div>

            <div className="maincheck">
              <label
                className={`material-checkbox ${errors.agreed ? "checkbox-error" : ""
                  }`}
              >
                <input
                  type="checkbox"
                  name="agreed"
                  checked={form.agreed}
                  onChange={handleChange}
                />
                <span className="checkmark"></span>
              </label>
              I confirm that I represent this company or have permission to submit this request.
            </div>

            <button
              className="request"
              disabled={loading}
              onClick={handleSubmit}
            >
              {loading ? "Submitting..." : "Submit Company Request"}
            </button>

            <div className="brdr"></div>
            <h6>
              Need help accessing your account? <a href="/contact">Contact</a> TRAQSTOCK
              support
            </h6>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        className="join"
        show={showSubmitted}
        onHide={handleCloseSubmitted}
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <span className="green">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path d="M8.3335 23.3333L14.1668 29.1667L31.6668 10.8333" stroke="#10B981" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
            <h2>Request Submitted Successfully</h2>
            <p>
              Thank you for contacting TRAQSTOCK. Our team will review your
              request and reach out with the next steps.
            </p>
            <button className="close" onClick={handleCloseSubmitted}>
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal className="join" show={showUnable} onHide={handleCloseUnable} centered>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div className="maincontent">
            <span className="red">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                <path d="M23.2077 35H16.7917C9.07428 35 5.2156 35 3.79361 32.4898C2.37163 29.9798 4.34528 26.6523 8.29258 19.9975L11.5006 14.5889C15.2923 8.1963 17.1882 5 19.9997 5C22.8112 5 24.707 8.19628 28.4987 14.5889L31.7068 19.9975C35.654 26.6523 37.6277 29.9798 36.2057 32.4898C34.7837 35 30.925 35 23.2077 35Z" stroke="#EF4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 28.3333V20.8333" stroke="#EF4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M20 14.9971V14.9805" stroke="#EF4444" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </span>
            <h2>Unable to Submit Request</h2>
            <p>
              We couldn't process your submission right now. Please check your
              information and try again.
            </p>
            <button className="close" onClick={handleCloseUnable}>
              Try Again
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Registermodal;